import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import 'src/styles/app.scss';
import { KatSpinner } from '@amzn/katal-react'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';

import App from './components/App';
import AppInitWrapper from './components/AppInitWrapper';
import { StencilProvider } from '@amzn/stencil-react-components/context';
import { getStencilTheme, getStencilThemeMode } from 'src/utils/theme';
import './js/localization';
// Emits the transactional email template assets to images/email/; not rendered by the app.
import 'src/images/email';

// The Suspense component causes React to display the fallback KatSpinner until
// the i18n translation strings have been loaded.

const root = createRoot(document.getElementById('root')!);
root.render(
    <React.StrictMode>
        <StencilProvider
            theme={getStencilTheme()}
            themeMode={getStencilThemeMode()}
        >
            <AppInitWrapper>
                <Suspense fallback={<KatSpinner size='large' />}>
                    <App />
                </Suspense>
            </AppInitWrapper>
        </StencilProvider>
    </React.StrictMode>
);